module.exports = __webpack_public_path__ + "img/Sintomas Cancro Europeu na Colheita 5.a360356e.webp";